import template from './contactsMailChimp.template.html';

export default {
  bindings: {
    contacts: '<',
    selectedIdContacts: '<',
    onClosed: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, mailChimpService, uiService) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentOrganization = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.contacts = ctrl.contacts || [];
        ctrl.selectedIdContacts = ctrl.selectedIdContacts || [];
        ctrl.filteredSelectedContacts = _.filter(
          ctrl.contacts,
          (c) =>
            c?.isMarketing && c?.getEmail() && _.indexOf(ctrl.selectedIdContacts, c?.id) > -1
        );
        if (ctrl.filteredSelectedContacts.length) {
          $mdDialog
            .show({
              locals: {
                organization: ctrl.currentOrganization,
                contacts: ctrl.filteredSelectedContacts
              },
              template,
              controllerAs: '$ctrl',
              controller(organization, contacts) {
                const self = this;
                self.organization = organization;
                self.contacts = contacts;
                self.lists = [];
                self.idList = '';
                self.listName = '';
                self.isReady = false;

                mailChimpService.lists().then((lists) => {
                  self.lists = lists;
                  self.isReady = true;
                });

                self.confirm = () => {
                  if (self.idList !== '') {
                    self.listName = _.find(self.lists, (list) => list.id === self.idList).name;
                  }
                  $mdDialog.hide({
                    id: self.idList,
                    name: self.listName,
                    idContacts: _.map(self.contacts, 'id')
                  });
                };
                self.cancel = () => {
                  ctrl.onClosed();
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              mailChimpService.listAddTo(result).then((res) => {
                if (res.status) {
                  uiService.toast({
                    text: {
                      p1: `${result.idContacts.length} contact(s)`,
                      p2: 'are being added',
                      p3: `to ${result.name} MailChimp list`
                    },
                    progress: true,
                    warn: true
                  });
                } else {
                  uiService.toast({
                    text: {
                      p1: 'Something',
                      p2: 'went wrong',
                      p3: ', please try again later'
                    },
                    progress: true,
                    warn: true
                  });
                }
              });
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Selected Contact(s)',
              p2: 'have opted out of Marketing',
              p3: 'and/or are missing E-Mail'
            },
            warn: true
          });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
